import introJs from "intro.js";

import * as Intro from './_IntroBase';

export function addRelatedProcessStartIntro() {
    let $infoButton: JQuery = $('#related-process-intro');
    let $processListField: JQuery = $('#processlist-field');
    let $switchButton: JQuery = $('#toggle-process-filter');
    let $processList: JQuery = $('#ProcessListForProcessSelectPartial');

    addRelatedProcessInitSteps();
    modifyPointerEventsForTour(false);

    introJs()
        .setOption('exitOnOverlayClick', 'false')
        .setOption('prevLabel', 'Előző')
        .setOption('nextLabel', 'Következő')
        .setOption('skipLabel', 'x')
        .setOption('doneLabel', 'x')
        .setOption('showBullets', false)
        .onexit(function () {
            modifyPointerEventsForTour(true);
            window.SettingsManager.setAttribute('addRelatedProcessIntro', true);
        })
        .start();

    function addRelatedProcessInitSteps() {
        // (1/4) Információ gomb
        Intro.initFirstStepTemplateHeader($infoButton, 4);

        // (2/4) Eljárás lista táblázat
        $processListField.attr('data-step', 2);
        $processListField.attr('data-intro', Intro.introTemplateHeader('Hrsz. egyezés', 2, 4) + 'A továbbiakban a táblázatban csak azok az eljárások jelennek meg alapértelmezetten, melyeknél a település és hrsz. megegyezik a kiinduló eljáráséval, és a jelen hatóságnál megtalálható.');

        // (3/4) Minden eljárás megjelenítése gomb
        $switchButton.attr('data-step', 3);
        $switchButton.attr('data-intro', Intro.introTemplateHeader('Összes eljárás', 3, 4) + 'Ha szükséges, a táblázat feletti gombra kattintva betöltheti a hatóság összes eljárását.');

        // (4/4) Elköszönés
        Intro.initLastStepTemplateHeader($processList, 4);
    }

    function modifyPointerEventsForTour(isAuto: boolean) {
        var value = isAuto ? 'auto' : 'none';

        $infoButton.each(function () {
            this.style.pointerEvents = value;
        });

        $processListField.each(function () {
            this.style.pointerEvents = value;
        });

        $switchButton.each(function () {
            this.style.pointerEvents = value;
        });

        $processList.each(function () {
            this.style.pointerEvents = value;
        });
    }
}
